import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

/** Full-width, transparent container for a factory group/collection, holding a nested field grid. Kept
 * borderless so nested groups/collections render flush like the other factory fields (e.g. Property Address). */
export const FactoryGroupBlock = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
`

export const FactoryGroupTitle = styled.div`
  ${font('sm', 'bold')}
  color: var(--colour-text-primary, #222b33);
`

export const FactoryGroupDescription = styled.div`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #607890);
  margin-top: 0.125rem;
`

/** One field rendered as the agent sees it (label + read-only control). Used flush inside factory sections. */
export const FieldPreviewItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
`

export const PreviewSelectValue = styled.span`
  color: var(--colour-text-primary, #222b33);
`

export const PreviewOptionList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`

export const PreviewCheckMark = styled.span`
  width: 1rem;
  height: 1rem;
  border-radius: 0.25rem;
  border: 1px solid var(--neutral-200, #c3ccd5);
  flex-shrink: 0;
`

export const FactoryAddNote = styled.div`
  ${font('xs', 'bold')}
  color: var(--colour-text-action, #a1244d);
`

export const FactoryUploadBox = styled.div`
  ${font('sm', 'regular')}
  border: 1px dashed var(--neutral-150, #d8dee4);
  border-radius: 0.375rem;
  padding: 1.25rem;
  text-align: center;
  color: var(--colour-text-secondary, #8c99a8);
  background-color: white;
`
